import { Button, Modal } from "antd";
import "./style.scss";
import { useInfoUser } from "../../../store/UserStore";

const OverRecipientModal = ({
  title,
  content,
  onCancel,
  open,
  onConfirm,
  confirmText,
  cancelText,
}) => {
  const { languageMap } = useInfoUser();

  return (
    <Modal
      width={450}
      open={open}
      onCancel={onCancel}
      footer={null}
      maskClosable={false}
      centered
      className="over-recipient-modal"
    >
      <div className="modal-header">
        <div className="modal-title">{title ?? "Xác nhận"}</div>
        <div className="modal-divider" />
      </div>

      <div className="text-base mb-6">{content}</div>

      <div className="flex justify-end gap-2">
        <Button
          className="!bg-[#ffffff] !text-black hover:!bg-[#d9d9d9] font-medium w-[80px]"
          onClick={onCancel}
        >
          {cancelText ?? languageMap?.["modal.cancel"] ?? "Cancel"}
        </Button>
        <Button
          className="!bg-[#2a56b9] !text-white hover:!bg-[#2a56b9] font-medium w-[80px]"
          onClick={() => {
            onConfirm(false);
            onCancel();
          }}
        >
          {confirmText ?? languageMap?.["modal.un-notify-ok"] ?? "Send"}
        </Button>
        <Button
          className="!bg-[#3cb371] !text-white hover:!bg-[#3cb371] font-medium w-[80px]"
          onClick={() => {
            onConfirm(true);
            onCancel();
          }}
        >
          {confirmText ?? languageMap?.["modal.notify-ok"] ?? "Notify"}
        </Button>
      </div>
    </Modal>
  );
};

export { OverRecipientModal };
